import { render, staticRenderFns } from "./textTranslation.vue?vue&type=template&id=0e2ec536&scoped=true&"
import script from "./textTranslation.vue?vue&type=script&lang=js&"
export * from "./textTranslation.vue?vue&type=script&lang=js&"
import style0 from "./textTranslation.vue?vue&type=style&index=0&id=0e2ec536&scoped=true&lang=css&"
import style1 from "./textTranslation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2ec536",
  null
  
)

export default component.exports